import * as React from "react"
export const Svg_042 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M30.7 23.514v9.497c3.498-.791 6.123-3.974 6.123-7.768 0-4.388-3.51-7.957-7.823-7.957-4.313 0-7.823 3.57-7.823 7.957 0 3.794 2.625 6.977 6.124 7.768v-9.497h3.398Z"
      />
      <path
        fill="url(#c)"
        d="M29 8.643c-8.998 0-16.319 7.447-16.319 16.6 0 8.57 6.417 15.643 14.62 16.51v-5.226c-5.384-.836-9.522-5.578-9.522-11.284 0-6.294 5.034-11.415 11.221-11.415s11.221 5.12 11.221 11.415c0 5.706-4.138 10.448-9.522 11.284v5.227c8.203-.868 14.62-7.941 14.62-16.511 0-9.153-7.32-16.6-16.319-16.6Z"
      />
      <path
        fill="url(#d)"
        d="M9.283 25.243c0-11.06 8.845-20.057 19.717-20.057 10.872 0 19.717 8.997 19.717 20.057 0 10.477-7.938 19.104-18.018 19.983v5.202c5.989-.41 11.564-2.978 15.848-7.336 4.687-4.767 7.268-11.107 7.268-17.85 0-6.742-2.581-13.08-7.268-17.849C41.86 2.626 35.628 0 29 0S16.14 2.626 11.453 7.393C6.766 12.161 4.185 18.5 4.185 25.243c0 6.742 2.581 13.082 7.268 17.85 4.284 4.357 9.859 6.926 15.848 7.335v-5.202C17.22 44.347 9.283 35.72 9.283 25.243Z"
      />
      <path
        fill="url(#e)"
        d="M27.3 50.486v2.51l-3.498 3.56L26.205 59 29 56.157 31.795 59l2.403-2.444-3.499-3.56v-2.51h-3.398Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={24.795}
        x2={32.282}
        y1={19.644}
        y2={31.699}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={20.229}
        x2={36.057}
        y1={13.609}
        y2={38.86}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={15.662}
        x2={39.784}
        y1={7.564}
        y2={45.987}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={26.206}
        x2={29.85}
        y1={51.763}
        y2={58.963}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h58v59H0z" />
      </clipPath>
    </defs>
  </svg>
)